// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "xyz.orion",
    name: "Orion",
    homepage: "https://orion.xyz",
    image_id: "85007828-9522-4517-6a55-6f376de8a500",
    app: {
        browser: null,
        ios: "https://itunes.apple.com/app/id1659758160",
        android: null,
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "orion://wc?",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map